import { type SugarMessage } from '@app/types'
import axios from 'axios'

// Translate axios errors thrown by useUploadProviderPhoto / useDeleteProviderPhoto
// into a single user-facing notification. Server-supplied `error_message` (Sugar
// native envelope) wins when present — the backend ships strong copy like
// "Photo limit reached (3). Delete an existing photo before adding another."
export const mapPhotoUploadError = (err: unknown): SugarMessage => {
  if (axios.isAxiosError(err) && err.response) {
    const status = err.response.status
    const body = err.response.data as
      | { error_message?: string; messages?: { message?: string }[] }
      | undefined
    const serverMessage = body?.error_message ?? body?.messages?.[0]?.message

    if (serverMessage) {
      return { message: serverMessage, type: 'error' }
    }

    if (status === 413) {
      return { message: 'Photo is too large. Maximum size is 5 MB.', type: 'error' }
    }
    if (status === 422) {
      return { message: 'Photo must be JPEG or PNG, no larger than 5 MB.', type: 'error' }
    }
    if (status === 403) {
      return { message: "You don't have permission to manage photos for this site.", type: 'error' }
    }
    if (status === 404) {
      return { message: 'That photo no longer exists. The list has been refreshed.', type: 'warning' }
    }
  }

  if (err instanceof Error) {
    return { message: err.message || 'Could not upload photo. Please try again.', type: 'error' }
  }

  return { message: 'Could not upload photo. Please try again.', type: 'error' }
}
